export default { buildTime: '2026-01-26T17:50:55+08:00' }